'use client';

import React, { useState, useEffect } from 'react';
import Image, { ImageProps } from 'next/image';
import { normalizeAssetPathUrl } from '@/lib/utils';

interface CustomImageProps extends Omit<ImageProps, 'src'> {
  src: string;
  storeSlug?: string;
  fallbackImage?: any;
}

const CustomImage: React.FC<CustomImageProps> = ({ src, storeSlug = '', fallbackImage = null, ...props }) => {
  const [imageSrc, setImageSrc] = useState(() => normalizeAssetPathUrl(src, storeSlug));
  const [errorCount, setErrorCount] = useState(0);

  useEffect(() => {
    setImageSrc(normalizeAssetPathUrl(src, storeSlug));
    setErrorCount(0);
  }, [src, storeSlug]);

  const handleError = () => {
    if (errorCount === 0 && fallbackImage?.src) {
      setImageSrc(normalizeAssetPathUrl(src, storeSlug));
      setErrorCount((prevCount) => prevCount + 1);
    } else {
      setImageSrc('/missing_image.png');
    }
  };

  // *** below is suppressed to avoid es lint warnings about alt element not being present
  // *** we're assuming that alt is part of the props and will be unfurled accordingly
  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image src={imageSrc} {...props} onError={handleError} />;
};

export default CustomImage;
